import { render, staticRenderFns } from "./LastWeekRestCard.vue?vue&type=template&id=0c9a8bbf"
import script from "./LastWeekRestCard.vue?vue&type=script&lang=js"
export * from "./LastWeekRestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports